import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NominativeService} from "../../core/services/routes-services/nominative.service";
import {Observable, of, tap} from "rxjs";
import {NominativeInfo} from "../../core/interfaces/name-list.interface";
import {catchError, map} from "rxjs/operators";
import {BaseSelect} from "../../core/classes/base.component";

@Component({
    selector: 'app-nominative-select',
    exportAs: 'ngModel',
    templateUrl: './nominative-select.component.html',
    styleUrls: ['./nominative-select.component.scss']
})
export class NominativeSelectComponent extends BaseSelect<NominativeInfo> {

    @Output() selectionChanged = new EventEmitter<any>();
    @Input()
    customer: boolean = false
    @Input()
    supplier: boolean = false

    constructor(
        private _service: NominativeService,
    ) {
        super(true)
    }

    trackByFn(item: NominativeInfo) {
        return item.id;
    }

    override executeRequest(term): Observable<any> {
        return this._service.filter(term, this.request()).pipe(
            map(res => {
                return res.data as NominativeInfo[]
            }),
            catchError(() => of([])), // empty list on error
            tap(() => (this.loading = false)),
        )
    }

    override fill(filters: any) {
        super.fillBasicFilters(filters, 'ACCOUNT')
        if(this.customer || this.supplier) {
            filters.ACCOUNT.types = []
            if(this.customer)
                filters.ACCOUNT.types.push('customer')
            if(this.supplier)
                filters.ACCOUNT.types.push('supplier')
        }
    }

    notifySelectionChanged: boolean = true
    // @Input() @Output()
    // value: any
    onSelectionChange(ev) {
        if(this.notifySelectionChanged)
            this.selectionChanged.emit(ev)
    }

    get value(): any {
        return this.selectedEntries;
    }

    set value(value: any) {
        this.selectedEntries = value;
    }

    updateEntries(value: any, skipNotifySelectionChanged: boolean = false) {
        this.notifySelectionChanged = !skipNotifySelectionChanged
        if(value) {
            const item = {
                id: value.id,
                name: value.businessName,
                disabled: value.state != 1,
                data: value
            } as unknown as NominativeInfo
            this.entries = [item];
            this.selectedEntries = item;
            this.select.itemsList.setItems(this.entries)
            this.select.select(this.select.itemsList.items[0])
        }
        else {
            this.entries = [];
            this.selectedEntries = null;
            this.select.itemsList.setItems(this.entries)
        }
        this.notifySelectionChanged = true
    }

}
